// PHIÊN BẢN PLUGIN TỐI THIỂU của một bundle (2026-10-02). Bundle dùng tính năng runner mới mà chạy trên plugin cũ thì hỏng GIỮA CHỪNG
// (vd. "Hàm không được phép: ma_video" ở bước bình luận, sau khi đã làm vài việc thật). Vì vậy:
//  - lúc biên dịch (dichSoDo đường Boss, Tự dựng trên plugin) bundle tự khai `can_plugin` = phiên bản plugin thấp nhất chạy được nó — SUY RA từ
//    nội dung (tất định), không ai gõ tay; bundle không dùng tính năng mới thì KHÔNG có trường này (hash không đổi, bot cũ chạy như trước);
//  - Boss chặn giao bundle cho bot có phiên bản thấp hơn (server/src/plugin-toi-thieu.ts), lý do rõ;
//  - plugin tự kiểm trước khi chạy (src/background/runner.ts) — dừng ngay từ đầu nếu bundle cần bản cao hơn mình.
// Đặt hằng ở MỘT chỗ này. Thêm tính năng runner mới mà bản cũ không hiểu → thêm hằng + luật nhận dạng trong suyCanPlugin + nâng PHIEN_BAN_TINH_NANG.

/** Action.chot (chốt trước thao tác) + hàm biểu thức ma_video — có từ 0.1.39. (0.1.38 do phiên khác phát hành 04038fb TRƯỚC khi hai tính năng này
 *  vào main → 0.1.38 KHÔNG có chúng.) */
export const PLUGIN_CAN_CHO_CHOT = "0.1.39";
/** (04/10/2026) Bước đăng nhóm TỰ CHỌN NHÓM (BundleStep.chon_nhom với địa chỉ nhóm rỗng — bot chọn nhóm đã vào theo dữ liệu của mình, src/shared/nhom-fb.ts).
 *  Plugin cũ không hiểu → lướt trang chủ rồi mở địa chỉ rỗng. Có địa chỉ nhóm thì bước chạy đường cũ → không ràng buộc. */
export const PLUGIN_CAN_CHON_NHOM = "0.1.51"; // 0.1.50 đã phát hành (phiên khác, chống trùng + nhóm của nick) KHÔNG có tính năng này
/** (04/10/2026) Bình luận / trả lời KÈM ẢNH (BundleStep.kem_anh với che_do luon/ti_le — src/shared/kem-anh.ts). Plugin cũ bỏ qua khoá lạ → gửi chỉ
 *  chữ, im lặng không đính ảnh → bundle có tính năng này khai can_plugin để Boss không giao cho bot cũ. kem_anh = khong → không có khoá → không ràng buộc. */
export const PLUGIN_CAN_KEM_ANH = "0.1.52";
/** (04/10/2026) Rào BÀI ĐÍCH (Locator.vung = "bai_dich" — src/content/dom.ts khungBaiDich): sửa lỗi bình luận NHẦM BÀI của binh_luan_mot_bai Facebook (ô bài
 *  chính vẽ muộn → nhận ô bài gợi ý). Plugin cũ không biết giá trị này thì coi như KHÔNG có vùng (nhận ô ở bất kỳ đâu trừ chat) → tệ hơn cả trước → bundle
 *  có rào này phải chạy trên plugin mới. 0.1.52 (kèm ảnh) phát hành từ main TRƯỚC bản sửa này → không có. */
export const PLUGIN_CAN_BAI_DICH = "0.1.53";
/** (04/10/2026) Hậu kiểm của bước (postcondition) dùng biến {{cau_da_go}} = câu ĐÃ GÕ thật, kể cả câu người duyệt sửa (src/background/runner.ts ctxHauKiem) —
 *  vd. "câu trả lời nằm dưới ĐÚNG bình luận cha" của tra_loi_mot_binh_luan Facebook. Plugin cũ không có biến này → "Biến không tồn tại" SAU khi đã gửi. */
export const PLUGIN_CAN_CAU_DA_GO = "0.1.53";
/** (05/10/2026) Lướt CHỈ nhóm đã tham gia hợp từ khoá (CauHinhLuot.chi_nhom_da_vao — biến thể tự tìm của "bình luận một bài" Facebook để trống địa chỉ):
 *  plugin cũ không biết cờ này → lướt trang chủ / nhóm đang chọn để đăng, hoặc DỪNG cả lượt khi không có nhóm hợp (thay vì "không có việc"). */
export const PLUGIN_CAN_TU_TIM_NHOM = "0.1.54";
/** (05/10/2026) Lướt bảng tin thích NHIỀU hơn 5 bài (CauHinhLuot.so_thich > 5 — số bài thích chỉ là khuyến nghị, không còn trần 3): runner ≤ 0.1.53 kẹp
 *  lặng lẽ ở 5 → bundle đặt > 5 phải chạy trên bản mới. */
export const PLUGIN_CAN_THICH_NHIEU = "0.1.54";

/** (05/10/2026) Kèm ảnh theo TẬP ẢNH người dùng chọn trong Kho ảnh (BundleStep.kem_anh.anh_chon — src/shared/kho-anh.ts): bot hỏi Boss đúng tập đó rồi lấy
 *  ngẫu nhiên. Plugin cũ bỏ qua khoá lạ → lấy ảnh SẢN PHẨM (ngoài tập người dùng chọn) → bundle có anh_chon phải chạy trên plugin mới. */
export const PLUGIN_CAN_ANH_CHON = "0.1.54";

/** (05/10/2026) TỰ TRẢ LỜI hộp câu hỏi kiểm duyệt khi xin vào nhóm Facebook (NhanhKetQua.tra_loi.bat = co — src/shared/cau-hoi-nhom.ts). Plugin cũ bỏ qua
 *  khoá lạ → đóng hộp, "cần người" như trước (không hỏng giữa chừng nhưng KHÔNG làm điều người dùng chọn) → bundle bật tính năng phải chạy trên plugin mới. */
export const PLUGIN_CAN_TRA_LOI_CAU_HOI = "0.1.55";

/** (05/10/2026) ĐIỀU KHIỂN TỪ XA BỞI NGƯỜI trên Boss ("Giải CAPTCHA" — src/shared/dieu-khien-tu-xa.ts, src/background/dieu-khien-tu-xa.ts): Boss gửi view.input.start
 *  xuống bot. Plugin cũ bỏ qua tin lạ → hộp trên Boss treo — nên Boss/web CHẶN mở phiên với bot có phiên bản thấp hơn và nói rõ "cần cập nhật plugin lên 0.1.56".
 *  KHÔNG nâng PHIEN_BAN_TINH_NANG theo hằng này: không phải tính năng của bundle (bot dev vẫn mang số manifest cũ → phải cập nhật manifest khi phát hành). */
export const PHIEN_BAN_DIEU_KHIEN_TU_XA = "0.1.56";

/** (06/10/2026) "CHỜ GIỮA CÁC LẦN" (BundleStep.cho_giua — src/shared/cho-giua-lan.ts) và TỪ KHOÁ NHIỀU DÒNG (tham số `<từ khoá>_cau_hinh` + BundleStep.ds_tu_khoa —
 *  src/shared/tu-khoa-nhieu-dong.ts: số lượng mỗi từ khoá, xoay theo GIỜ, dùng tất cả từ khoá). Plugin cũ bỏ qua khoá lạ → chạy KHÔNG chờ theo ô đã đặt / dùng cả chuỗi
 *  "a | b" làm một từ khoá → bundle có các khoá này khai can_plugin. Chỉ có khi người dùng ĐIỀN (bỏ trống = bundle / hash như cũ, không ràng buộc).
 *  KHÔNG nâng PHIEN_BAN_TINH_NANG theo hằng này (như PHIEN_BAN_DIEU_KHIEN_TU_XA): bản dựng dev mang số manifest cũ sẽ từ chối bundle loại này cho tới khi phát hành 0.1.58. */
export const PLUGIN_CAN_CHO_GIUA_LAN = "0.1.58";
export const PLUGIN_CAN_TU_KHOA_NHIEU_DONG = "0.1.58";
/** (07/10/2026) DÙNG MỘT THAO TÁC NHIỀU LẦN trong một kịch bản (src/shared/lan-dung.ts, khoi-lan-n.ts): lần dùng thứ n ≥ 2 mang hậu tố `_n` ở id bước + tên tham số kịch bản. Plugin ≤ 0.1.59 chạy được mọi
 *  bundle loại này (id / tham số chỉ là tên) TRỪ hai chỗ gắn cứng tên: (1) tham số từ khoá của lần n ≥ 2 (tu_khoa_2, tu_khoa_nhom_3, …cau_hinh_n) có NHIỀU từ khoá / cấu hình — runner cũ chỉ xoay đúng tên
 *  `tu_khoa` / `tu_khoa_nhom` nên dùng cả chuỗi "a | b" làm MỘT từ khoá; (2) hai bước làm việc trên CÙNG danh sách liền nhau thuộc hai lần dùng khác nhau — runner cũ gộp thành một chuỗi "soạn → đăng"
 *  (src/background/runner.ts buocLapTruoc) làm bù mục sai. Bundle không dính hai chỗ này (đa số: kịch bản cũ, hoặc dùng lại thao tác với từ khoá một dòng) KHÔNG bị ràng buộc — hash và bot cũ như trước.
 *  KHÔNG nâng PHIEN_BAN_TINH_NANG theo hằng này (như PLUGIN_CAN_CHO_GIUA_LAN) và KHÔNG nâng manifest: bản dựng dev mang số cũ từ chối bundle loại này cho tới khi phát hành 0.1.60. */
export const PLUGIN_CAN_KHOI_LAP_LAI = "0.1.60";
/** (07/10/2026) LƯỚT LÂU HƠN 270 giây (luot.giay > 270 — "lướt bảng tin 5 phút"): runner ≤ 0.1.59 lấy ngân sách lướt = timeout bước (300 s) − 30 s nên kẹp LẶNG LẼ ở 270 s → bundle đặt dài hơn phải chạy trên plugin mới.
 *  Cùng quy ước với PLUGIN_CAN_KHOI_LAP_LAI: không nâng PHIEN_BAN_TINH_NANG / manifest. Bundle lướt ≤ 270 s (mọi kịch bản cũ) không bị ràng buộc. */
export const PLUGIN_CAN_LUOT_DAI = "0.1.60";
/** (07/10/2026) THAO TÁC XÂY KÊNH MỚI (theo dõi / chia sẻ / đăng bài kênh / số liệu kênh / tin nhắn / hồ sơ — src/shared/khoi-*.ts):
 *  (1) hạn mức RIÊNG mỗi ngày loại mới (BundleStep.dem_ngay khác "tham_gia_nhom" — src/shared/han-muc-ngay.ts): plugin ≤ 0.1.63 chỉ biết tham_gia_nhom → bỏ qua LẶNG LẼ
 *      (theo dõi / nhắn tin không giới hạn mỗi ngày);
 *  (2) báo số liệu kênh (BundleStep.bao_so_lieu — src/shared/so-lieu-kenh.ts): plugin cũ bỏ qua → Boss không nhận được số liệu;
 *  (3) vùng TIN NHẮN (Locator.vung = "tin_nhan" — chỉ ô soạn trong khung chat của trang hộp thư): plugin cũ coi như không có vùng → loại mọi ô chat → bước hỏng.
 *  Cùng quy ước PLUGIN_CAN_KHOI_LAP_LAI: không nâng PHIEN_BAN_TINH_NANG / manifest — bản dựng dev mang số cũ từ chối bundle loại này cho tới khi phát hành 0.1.64. */
export const PLUGIN_CAN_KENH_MOI = "0.1.64";
/** (08/10/2026) ĐỢT B — ô tuỳ chọn theo bước (src/shared/tuy-chon-buoc.ts): han_ngay (hạn mức ngày của bước), nhac_sp (tỉ lệ nhắc riêng / bắt buộc có tên), xem_truoc, khoang_nghi,
 *  lap_theo_gio / so_muc / chon_thich / tim_khi_luot (lướt theo phút, số mục và lượt thích ngẫu nhiên), mo_truoc, luot.phut_tu / phut_den / so_thich_tu. Plugin cũ bỏ qua khoá lạ →
 *  làm KHÁC ý người dùng (không giới hạn, nhắc sai tỉ lệ, không xem trước…) → bundle có khoá nào trong số này khai can_plugin. Chỉ có khi người dùng ĐẶT ô (bỏ trống = bundle như cũ).
 *  Cùng quy ước PLUGIN_CAN_KHOI_LAP_LAI: không nâng PHIEN_BAN_TINH_NANG / manifest. */
export const PLUGIN_CAN_DOT_B = "0.1.65";
/** (16/10/2026) LIÊN KẾT QUẢNG BÁ (knowledge.lien_ket — src/shared/hook-lien-ket.ts): runner NỐI liên kết vào cuối câu bình luận / bài đăng sau khi câu qua kiểm nội dung. Plugin cũ bỏ qua
 *  khoá lạ → đăng chỉ chữ, im lặng không có liên kết (đúng lỗi người dùng báo 16/10) → bundle có liên kết khai can_plugin. Không nâng PHIEN_BAN_TINH_NANG / manifest (như PLUGIN_CAN_DOT_B). */
export const PLUGIN_CAN_LIEN_KET = "0.1.71";
const KHOA_BUOC_DOT_B = ["han_ngay", "nhac_sp", "xem_truoc", "khoang_nghi", "lap_theo_gio", "so_muc", "chon_thich", "tim_khi_luot", "mo_truoc"] as const;
function canDotB(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => {
    if (!s || typeof s !== "object") return false;
    const o = s as Record<string, unknown>;
    if (KHOA_BUOC_DOT_B.some((k) => o[k] !== undefined && o[k] !== null)) return true;
    const l = o.luot as Record<string, unknown> | undefined;
    if (l && typeof l === "object" && (l.phut_tu !== undefined || l.phut_den !== undefined || l.so_thich_tu !== undefined)) return true;
    return canDotB(o.steps);
  });
}

/** Mức tính năng mã nguồn này hỗ trợ (max mọi hằng ở trên). Bản dựng dev trước khi phát hành còn mang số manifest cũ nhưng đã có tính năng → bot
 *  báo kèm mức này trong lời chào (BotHello.tinhNang) và tự kiểm theo max(manifest, mức này). */
export const PHIEN_BAN_TINH_NANG = PLUGIN_CAN_DANG_VIDEO; // 0.1.57 (06/10/2026: bước Đăng video; > 0.1.55 của PLUGIN_CAN_TRA_LOI_CAU_HOI)

import { hauToLanCuaBuoc } from "./lan-dung";
import { laKemAnhBat } from "./kem-anh";
import { laBatTuTraLoi } from "./cau-hoi-nhom";
import { PLUGIN_CAN_DANG_VIDEO } from "./video-dang";

const RE_PHIEN_BAN = /^\d{1,6}(\.\d{1,6}){0,3}$/;
export function laPhienBan(x: unknown): x is string {
  return typeof x === "string" && RE_PHIEN_BAN.test(x);
}

/** So theo từng đoạn số (1.10.0 > 1.9.0; thiếu đoạn = 0). Âm: a < b. */
export function soSanhPhienBan(a: string, b: string): number {
  const pa = a.split(".").map((x) => parseInt(x, 10) || 0);
  const pb = b.split(".").map((x) => parseInt(x, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d) return d;
  }
  return 0;
}

const lonHon = (a: string | null, b: string | null): string | null => (!a ? b : !b ? a : soSanhPhienBan(a, b) >= 0 ? a : b);

const RE_MA_VIDEO = /\bma_video\s*\(/;

/** Phiên bản plugin thấp nhất chạy được bundle = max(`can_plugin` khai sẵn hợp lệ, phiên bản suy từ tính năng dùng trong bundle). null = không ràng buộc. */
export function suyCanPlugin(bundle: unknown): string | null {
  if (!bundle || typeof bundle !== "object" || Array.isArray(bundle)) return null;
  const khai = (bundle as Record<string, unknown>).can_plugin;
  let can: string | null = laPhienBan(khai) ? khai : null;
  let dungChot = false;
  const duyet = (v: unknown): void => {
    if (dungChot) return;
    if (typeof v === "string") { if (RE_MA_VIDEO.test(v)) dungChot = true; return; }
    if (Array.isArray(v)) { for (const x of v) duyet(x); return; }
    if (!v || typeof v !== "object") return;
    for (const [k, x] of Object.entries(v as Record<string, unknown>)) {
      // Action.chot = { cond, ly_do } — chỉ KHOÁ có hình dạng đó mới tính (tham số / dữ liệu tên "chot" thì không).
      if (k === "chot" && x && typeof x === "object" && !Array.isArray(x) && "cond" in x) { dungChot = true; return; }
      duyet(x);
    }
  };
  duyet((bundle as Record<string, unknown>).steps);
  if (!dungChot) duyet((bundle as Record<string, unknown>).interrupts);
  if (dungChot) can = lonHon(can, PLUGIN_CAN_CHO_CHOT);
  if (canChonNhom(bundle as Record<string, unknown>)) can = lonHon(can, PLUGIN_CAN_CHON_NHOM);
  if (canKemAnh((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_KEM_ANH);
  if (canBaiDich((bundle as Record<string, unknown>).steps) || canBaiDich((bundle as Record<string, unknown>).interrupts)) can = lonHon(can, PLUGIN_CAN_BAI_DICH);
  if (canCauDaGo((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_CAU_DA_GO);
  if (canTuTimNhom((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_TU_TIM_NHOM);
  if (canThichNhieu(bundle as Record<string, unknown>)) can = lonHon(can, PLUGIN_CAN_THICH_NHIEU);
  if (canAnhChon((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_ANH_CHON);
  if (canTraLoiCauHoi((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_TRA_LOI_CAU_HOI);
  if (canChoGiua((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_CHO_GIUA_LAN);
  if (canTuKhoaNhieuDong(bundle as Record<string, unknown>)) can = lonHon(can, PLUGIN_CAN_TU_KHOA_NHIEU_DONG);
  if (canKhoiLapLai(bundle as Record<string, unknown>)) can = lonHon(can, PLUGIN_CAN_KHOI_LAP_LAI);
  if (canLuotDai(bundle as Record<string, unknown>)) can = lonHon(can, PLUGIN_CAN_LUOT_DAI);
  if (canDangVideo((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_DANG_VIDEO);
  if (canKenhMoi((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_KENH_MOI);
  if (canDotB((bundle as Record<string, unknown>).steps)) can = lonHon(can, PLUGIN_CAN_DOT_B);
  { const kn = (bundle as Record<string, unknown>).knowledge; const lk = kn && typeof kn === "object" ? (kn as Record<string, unknown>).lien_ket : undefined; if (typeof lk === "string" && lk.trim()) can = lonHon(can, PLUGIN_CAN_LIEN_KET); }
  return can;
}

/** (07/10/2026) Có bước (kể cả bước con) dùng tính năng của thao tác xây kênh mới — xem PLUGIN_CAN_KENH_MOI: dem_ngay loại mới, bao_so_lieu, locator vung "tin_nhan". */
function canKenhMoi(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  const coVungTinNhan = (v: unknown): boolean => {
    if (!v || typeof v !== "object") return false;
    if (Array.isArray(v)) return v.some(coVungTinNhan);
    const o = v as Record<string, unknown>;
    if (o.vung === "tin_nhan" && Array.isArray(o.ladder)) return true;
    return Object.values(o).some(coVungTinNhan);
  };
  return steps.some((s) => {
    if (!s || typeof s !== "object") return false;
    const o = s as Record<string, unknown>;
    if (typeof o.dem_ngay === "string" && o.dem_ngay !== "tham_gia_nhom") return true;
    if (o.bao_so_lieu && typeof o.bao_so_lieu === "object") return true;
    if (coVungTinNhan(o.actions) || coVungTinNhan(o.postcondition) || coVungTinNhan(o.bo_qua_khi)) return true;
    return canKenhMoi(o.steps);
  });
}

/** Có bước (kể cả bước con) mang cho_giua (khoảng chờ giữa các lần lặp). */
function canChoGiua(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => {
    if (!s || typeof s !== "object") return false;
    const c = (s as { cho_giua?: unknown }).cho_giua;
    return (!!c && typeof c === "object" && !Array.isArray(c)) || canChoGiua((s as Record<string, unknown>).steps);
  });
}

/** (07/10/2026) Bundle dùng thao tác nhiều lần mà plugin ≤ 0.1.59 chạy SAI — xem PLUGIN_CAN_KHOI_LAP_LAI. */
function canKhoiLapLai(bundle: Record<string, unknown>): boolean {
  const params = (bundle.params && typeof bundle.params === "object" ? bundle.params : {}) as Record<string, { default?: unknown } | undefined>;
  for (const [k, p] of Object.entries(params)) {
    const d = typeof p?.default === "string" ? p.default : "";
    if (/^tu_khoa(?:_nhom)?_\d+$/.test(k) && /[|\r\n]|%7C|%25/i.test(d)) return true; // từ khoá nhiều dòng của lần n ≥ 2
    if (/^tu_khoa(?:_nhom)?_cau_hinh_\d+$/.test(k) && d.trim() !== "") return true; // cấu hình từ khoá của lần n ≥ 2
  }
  // Hai bước liền nhau cùng for_each, không có lọc, khác lần dùng (runner cũ coi là một chuỗi "soạn → đăng"). Bước máy chèn (chấm / lọc liên quan…) không thuộc lần dùng nào → bỏ qua.
  const duyet = (steps: unknown): boolean => {
    if (!Array.isArray(steps)) return false;
    for (let i = 0; i < steps.length; i++) {
      const s = steps[i] as { id?: unknown; for_each?: unknown; filter?: unknown; steps?: unknown } | undefined;
      const t = steps[i + 1] as typeof s;
      const a = hauToLanCuaBuoc(String(s?.id ?? "")), b = hauToLanCuaBuoc(String(t?.id ?? ""));
      if (s && t && typeof s.for_each === "string" && s.for_each === t.for_each && s.filter === undefined && t.filter === undefined && a !== null && b !== null && a !== b) return true;
      if (s && duyet(s.steps)) return true;
    }
    return false;
  };
  return duyet(bundle.steps);
}

/** Bundle có tham số kịch bản `*_cau_hinh` (cấu hình nhiều từ khoá) KHÁC RỖNG, hoặc bước mang ds_tu_khoa. */
function canTuKhoaNhieuDong(bundle: Record<string, unknown>): boolean {
  const params = (bundle.params && typeof bundle.params === "object" ? bundle.params : {}) as Record<string, { default?: unknown } | undefined>;
  if (Object.entries(params).some(([k, p]) => /^tu_khoa(?:_nhom)?_cau_hinh(?:_\d+)?$/.test(k) && typeof p?.default === "string" && p.default.trim() !== "")) return true;
  const duyet = (steps: unknown): boolean => Array.isArray(steps) && steps.some((s) => !!s && typeof s === "object" && (!!(s as { ds_tu_khoa?: unknown }).ds_tu_khoa || duyet((s as Record<string, unknown>).steps)));
  return duyet(bundle.steps);
}

/** Có bước (kể cả bước con) có nhánh kết quả tra_loi BẬT (giá trị đã lắp; chữ {{…}} chưa thay coi như bật — mặc định của tham số là co). */
/** (06/10/2026) Có bước (kể cả bước con) mang khoá dang_video — bước Đăng video từ Kho video. */
function canDangVideo(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => !!s && typeof s === "object" && (!!(s as { dang_video?: unknown }).dang_video || canDangVideo((s as Record<string, unknown>).steps)));
}

function canTraLoiCauHoi(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => {
    if (!s || typeof s !== "object") return false;
    const nh = (s as { nhanh_ket_qua?: unknown }).nhanh_ket_qua;
    if (Array.isArray(nh) && nh.some((n) => !!n && typeof n === "object" && !!(n as { tra_loi?: { bat?: unknown } }).tra_loi && laBatTuTraLoi((n as { tra_loi: { bat?: unknown } }).tra_loi.bat))) return true;
    return canTraLoiCauHoi((s as Record<string, unknown>).steps);
  });
}

/** Có bước lướt (kể cả bước con) mà luot.<truong> (số thẳng, hoặc {{tham_số}} lấy mặc định của tham số) > nguong. */
function canLuotLon(bundle: Record<string, unknown>, truong: "so_thich" | "giay", nguong: number): boolean {
  const params = (bundle.params && typeof bundle.params === "object" ? bundle.params : {}) as Record<string, { default?: unknown } | undefined>;
  const giaTri = (v: unknown): number => {
    const m = typeof v === "string" ? /^\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}$/.exec(v.trim()) : null;
    const x = m ? params[m[1]!]?.default : v;
    const n = typeof x === "number" ? x : typeof x === "string" && /^\s*\d+\s*$/.test(x) ? Number(x) : NaN;
    return Number.isFinite(n) ? n : 0;
  };
  const duyet = (steps: unknown): boolean => Array.isArray(steps) && steps.some((s) => !!s && typeof s === "object" && (giaTri((s as { luot?: Record<string, unknown> }).luot?.[truong]) > nguong || duyet((s as Record<string, unknown>).steps)));
  return duyet(bundle.steps);
}
/** Có bước lướt thích > 5 bài (PLUGIN_CAN_THICH_NHIEU). */
const canThichNhieu = (bundle: Record<string, unknown>): boolean => canLuotLon(bundle, "so_thich", 5);
/** Có bước lướt > 270 giây (PLUGIN_CAN_LUOT_DAI). */
const canLuotDai = (bundle: Record<string, unknown>): boolean => canLuotLon(bundle, "giay", 270);

/** Có bước (kể cả bước con) lướt với luot.chi_nhom_da_vao = true. */
function canTuTimNhom(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => !!s && typeof s === "object" && (((s as { luot?: { chi_nhom_da_vao?: unknown } }).luot?.chi_nhom_da_vao === true) || canTuTimNhom((s as Record<string, unknown>).steps)));
}

const RE_CAU_DA_GO = /\{\{[^}]*\bcau_da_go\b[^}]*\}\}/;
/** Có bước (kể cả bước con) mà postcondition dùng {{…cau_da_go…}}. kem_anh.hau_kiem dùng biến này từ 0.1.52 (đã tính ở canKemAnh) → không tính ở đây. */
function canCauDaGo(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => !!s && typeof s === "object" && (RE_CAU_DA_GO.test(JSON.stringify((s as Record<string, unknown>).postcondition ?? null)) || canCauDaGo((s as Record<string, unknown>).steps)));
}

/** Có locator (đối tượng có `ladder` là mảng) mang vung "bai_dich" ở bất kỳ đâu trong các bước (thao tác, hậu kiểm, bước con…). Chữ "bai_dich" làm dữ liệu
 *  (tham số, câu gõ, khoá `vung` của đối tượng không phải locator) không tính. */
function canBaiDich(v: unknown): boolean {
  if (!v || typeof v !== "object") return false;
  if (Array.isArray(v)) return v.some(canBaiDich);
  const o = v as Record<string, unknown>;
  if (o.vung === "bai_dich" && Array.isArray(o.ladder)) return true;
  return Object.values(o).some(canBaiDich);
}

/** Bundle có bước chon_nhom mà địa chỉ nhóm RỖNG (giá trị thẳng rỗng, hoặc {{tham_số}} có mặc định rỗng) → cần plugin biết tự chọn nhóm. */
function canChonNhom(bundle: Record<string, unknown>): boolean {
  const params = (bundle.params && typeof bundle.params === "object" ? bundle.params : {}) as Record<string, { default?: unknown } | undefined>;
  let can = false;
  const duyet = (v: unknown): void => {
    if (can || !v || typeof v !== "object") return;
    if (Array.isArray(v)) { for (const x of v) duyet(x); return; }
    const o = v as Record<string, unknown>;
    const cn = o.chon_nhom;
    if (cn && typeof cn === "object" && !Array.isArray(cn)) {
      const u = (cn as { url?: unknown }).url;
      const m = typeof u === "string" ? /^\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}$/.exec(u.trim()) : null;
      const gt = m ? params[m[1]!]?.default : u;
      if (typeof gt !== "string" || !gt.trim()) { can = true; return; }
    }
    for (const x of Object.values(o)) duyet(x);
  };
  duyet(bundle.steps);
  return can;
}

/** Có bước (kể cả bước con) mang kem_anh ĐANG BẬT (luon / ti_le). */
function canKemAnh(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => !!s && typeof s === "object" && (laKemAnhBat((s as Record<string, unknown>).kem_anh) || canKemAnh((s as Record<string, unknown>).steps)));
}

/** Có bước (kể cả bước con) mang kem_anh ĐANG BẬT với anh_chon khác rỗng (tập ảnh chọn trong Kho ảnh). */
function canAnhChon(steps: unknown): boolean {
  if (!Array.isArray(steps)) return false;
  return steps.some((s) => {
    if (!s || typeof s !== "object") return false;
    const k = (s as Record<string, unknown>).kem_anh as { anh_chon?: unknown } | undefined;
    return (laKemAnhBat(k) && typeof k!.anh_chon === "string" && k!.anh_chon.trim() !== "") || canAnhChon((s as Record<string, unknown>).steps);
  });
}

/** Gắn `can_plugin` vào bundle khi (và chỉ khi) có ràng buộc. Trả lại chính bundle. */
export function ganCanPlugin<T>(bundle: T): T {
  const can = suyCanPlugin(bundle);
  if (can) (bundle as unknown as Record<string, unknown>).can_plugin = can;
  return bundle;
}

/** Phiên bản hiệu lực của bot = max(phiên bản manifest, mức tính năng bot báo). Không có giá trị hợp lệ nào → null (= bot cũ, chưa báo). */
export function phienBanHieuLuc(extVersion: unknown, tinhNang: unknown): string | null {
  return lonHon(laPhienBan(extVersion) ? extVersion : null, laPhienBan(tinhNang) ? tinhNang : null);
}

/** Bot (phiên bản hiệu lực `ban`, null = chưa báo) chạy được bundle cần `can` (null = không ràng buộc) không. */
export function pluginDuDung(ban: string | null, can: string | null): boolean {
  if (!can) return true;
  if (!ban) return false;
  return soSanhPhienBan(ban, can) >= 0;
}

export function lyDoPluginCu(tenBot: string, ban: string | null, can: string): string {
  return `Bot “${tenBot}” đang chạy plugin ${ban ?? "cũ (chưa báo phiên bản)"} — kịch bản này cần ≥ ${can}. Hãy cập nhật plugin trên máy bot (tự cập nhật hoặc chạy cap-nhat-plugin.ps1)`;
}
